function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactTable from 'react-table';
import _cloneDeep from 'lodash/cloneDeep';
import _orderBy from 'lodash/orderBy';
import classnames from 'classnames';
import { filterMatch } from 'xps-react-utils';
import Pagination from '../Pagination';
import TableBody from './TableBody';
import TableData from './TableData';
import TableFilter from './TableFilter';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import TableRowGroup from './TableRowGroup';
import { getValidElementProps } from '../utils/htmlValidProps';
import { showWaypoint, showWaypointUp } from '../utils/waypointHelpers';

require('react-table/react-table.css');

require('xps-style/core/table.css');

var propTypes = {
  /** Description of the table */
  caption: PropTypes.string,

  /** Columns for your table. There is more customization can be done in this columns object. Please refer to https://react-table.js.org */
  columns: PropTypes.array,
  className: PropTypes.string,

  /** id of the table for accessibility purpose, passed down to sub components */
  id: PropTypes.string,

  /** Data for your table */
  data: PropTypes.array,

  /** defaultFilterMethod for the table */
  defaultFilterMethod: PropTypes.func,

  /** Number of rows of data by default */
  defaultPageSize: PropTypes.number,

  /** Enable columns to be filterable using search input below table header */
  filterable: PropTypes.bool,

  /** Make table a fixed height with a fixed header. You can put string ("500px") or number {500}  */
  fixedHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Get info on table cell state for modifying (e.g. on clicking the cell) */
  getTdProps: PropTypes.func,

  /** Get info on table row state for modifying (e.g. on clicking the row) */
  getTrProps: PropTypes.func,

  /** Displays minimum number of rows when filtered */
  minRows: PropTypes.number,

  /** Replace the entire no data message component with a functional render (function should return a Node) */
  noDataComponent: PropTypes.func,

  /** Textual message overlaid on the table when there are no data rows */
  noDataText: PropTypes.string,

  /** Table row height for table density level: small (32px), medium (40px), large (48px) */
  rowHeight: PropTypes.oneOf(['small', 'medium', 'large']),
  pageSizeDropUp: PropTypes.bool,

  /** Options for number of rows on display */
  pageSizeOptions: PropTypes.array,

  /** Display the page info (Page 1 of 10) on the left side of pagination */
  showPageInfo: PropTypes.bool,

  /** Include Pagination Component */
  showPagination: PropTypes.bool,

  /** Enable columns to be sortable */
  sortable: PropTypes.bool,

  /** Display page size options on the right side of pagination */
  showPageSizeOptions: PropTypes.bool,

  /** Style of table */
  striped: PropTypes.bool,

  /** Navigate table cell by cell using keyboard tab key */
  tabByCell: PropTypes.bool,

  /** Navigate table row by row using keyboard tab key */
  tabByRow: PropTypes.bool,

  /** Set to true to have virtual/infinite scrolling without pagination */
  virtualScroll: PropTypes.bool,

  /** Make virtualScroll table a fixed height with a fixed header. You can put string ("500px") or number {500}  */
  virtualScrollTableHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var defaultProps = {
  caption: '',
  columns: [],
  data: [],
  defaultPageSize: 10,
  filterable: false,
  fixedHeight: 'auto',
  minRows: 1,
  noDataComponent: null,
  noDataText: 'No results found.',
  pageSizeDropUp: false,
  rowHeight: 'medium',
  showPageInfo: true,
  showPageSizeOptions: true,
  showPagination: true,
  sortable: true,
  striped: false,
  tabByCell: false,
  tabByRow: true,
  virtualScroll: false
}; // Slice data from index to defaultPageSize * 2

export var getDataSlice = function getDataSlice(_ref) {
  var sortedData = _ref.sortedData,
      defaultPageSize = _ref.defaultPageSize,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index;

  if (!sortedData) {
    return [];
  }

  if (index === -1) {
    return sortedData;
  }

  if (index > sortedData.length - 1) {
    return sortedData;
  }

  var startIndex = index;

  if (index > defaultPageSize - 1) {
    startIndex = index - defaultPageSize;
  }

  if (startIndex < 0) {
    startIndex = 0;
  }

  return sortedData.slice(startIndex, index + defaultPageSize * 2);
};

var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props); // Used for getting ReactTable post-mount

    _defineProperty(_assertThisInitialized(_this), "getRowHeightNum", function () {
      var rowHeight = _this.props.rowHeight;

      switch (rowHeight) {
        case 'small':
          return 32;

        case 'medium':
          return 40;

        case 'large':
          return 48;

        default:
          return 40;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "makeFirstTableBodyCellTabbable", function () {
      var tabByRow = _this.props.tabByRow;

      if (!tabByRow && _this.tableBodyRef) {
        try {
          var firstTableBodyRow = _this.tableBodyRef.getElementsByClassName('rt-tr')[0];

          if (firstTableBodyRow) {
            _this.tableBodyRef.getElementsByClassName('rt-tr')[0].tabIndex = 0;
          }
        } catch (err) {// pass
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getWrappedInstance", function () {
      if (_this.wrappedInstance.getWrappedInstance) {
        return _this.wrappedInstance.getWrappedInstance();
      } else {
        return _this.wrappedInstance;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "filterDivsFromHTMLNodeList", function (HTMLNodeList) {
      return HTMLNodeList.nodeName === 'DIV';
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", function (event) {
      if (!event) {
        return;
      }

      var defaultPageSize = _this.props.defaultPageSize;
      var _this$state = _this.state,
          sortedData = _this$state.sortedData,
          index = _this$state.index;
      var currentlyActiveElementId = document.activeElement.children[0] ? document.activeElement.children[0].innerHTML : null;

      if (index < sortedData.length - 1) {
        var scrollPxAmount = defaultPageSize * _this.getRowHeightNum();

        _this.setState({
          index: index + defaultPageSize
        }, function () {
          _this.tableBodyScroll(scrollPxAmount);

          var intendedActiveElement = _toConsumableArray(_this.tableBodyRef.children).filter(_this.filterDivsFromHTMLNodeList).filter(function (item) {
            return item.children[0].innerHTML === currentlyActiveElementId;
          })[0];

          if (intendedActiveElement) {
            intendedActiveElement.focus();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadDataUp", function (event) {
      if (!event) {
        return;
      }

      var defaultPageSize = _this.props.defaultPageSize;
      var index = _this.state.index;
      var currentlyActiveElementId = document.activeElement.children[0] ? document.activeElement.children[0].innerHTML : null;

      if (index > defaultPageSize) {
        index -= defaultPageSize;
      } else {
        index = 0;
      }

      var scrollPxAmount = null;

      if (index === 0) {
        scrollPxAmount = 0;
      } else if (_this.tableBodyRef) {
        scrollPxAmount = defaultPageSize * _this.getRowHeightNum();
      }

      _this.setState({
        index: index
      }, function () {
        _this.tableBodyScroll(scrollPxAmount);

        var intendedActiveElement = _toConsumableArray(_this.tableBodyRef.children).filter(_this.filterDivsFromHTMLNodeList).filter(function (item) {
          return item.children[0].innerHTML === currentlyActiveElementId;
        })[0];

        if (intendedActiveElement) {
          intendedActiveElement.focus();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "customSort", function (col, desc, id, sortedData) {
      var sortMethod = col.sortMethod;

      var sortMethodWrapper = function sortMethodWrapper(left, right) {
        var res = 0;

        if (left[id] && right[id]) {
          res = sortMethod(left[id], right[id]);
        } // Generic default sortMethod


        if (left > right) {
          res = 1;
        }

        if (right > left) {
          res = -1;
        } // Flip sort around based on desc / asc


        return res * (desc ? 1 : -1);
      };

      sortedData.sort(sortMethodWrapper);
      return sortedData;
    });

    _defineProperty(_assertThisInitialized(_this), "genericSort", function (id, sorted, data) {
      var sortRow = function sortRow(row) {
        if (row[id] === null || row[id] === undefined) {
          return -Infinity;
        }

        return typeof row[id] === 'string' ? row[id].toLowerCase() : row[id];
      }; // This uses all possible ids, unlike custom sortMethod


      return _orderBy(data, sorted.map(function () {
        return sortRow;
      }), sorted.map(function (d) {
        return d.desc ? 'desc' : 'asc';
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tableState) {
        var _this$props, data, defaultFilterMethod, sortedData, filteredData, sorted, _sorted$, desc, id, columns, _columns$filter, _columns$filter2, col;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, data = _this$props.data, defaultFilterMethod = _this$props.defaultFilterMethod;
                sortedData = _cloneDeep(data);
                _context.next = 4;
                return sortedData.filter(function (row) {
                  var columnID = '';
                  var searchVal = '';

                  if (tableState.filtered[0] !== undefined) {
                    columnID = tableState.filtered[0].id;
                    searchVal = tableState.filtered[0].value;
                  }

                  var filterMethod = defaultFilterMethod ? defaultFilterMethod(tableState.filtered[0], row) : filterMatch(row[columnID], searchVal, true, true);
                  return tableState.filtered[0] !== undefined ? filterMethod : true;
                });

              case 4:
                filteredData = _context.sent;
                sortedData = filteredData;
                sorted = tableState.sorted;

                if (sorted.length > 0) {
                  // Search for primary sortMethod ([0])
                  _sorted$ = sorted[0], desc = _sorted$.desc, id = _sorted$.id;

                  if (id) {
                    columns = _this.props.columns; // Custom sortMethod for this column

                    _columns$filter = columns.filter(function (column) {
                      return column.accessor === id;
                    }), _columns$filter2 = _slicedToArray(_columns$filter, 1), col = _columns$filter2[0];

                    if (col && col.sortMethod) {
                      sortedData = _this.customSort(col, desc, id, sortedData);
                    } else {
                      sortedData = _this.genericSort(id, sorted, sortedData);
                    }
                  }
                }

                _this.setState({
                  sortedData: sortedData,
                  index: 0
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "calculateMinRows", function () {
      var _this$props2 = _this.props,
          filterable = _this$props2.filterable,
          fixedHeight = _this$props2.fixedHeight,
          minRows = _this$props2.minRows,
          showPagination = _this$props2.showPagination;
      var topMargin = 48 + (filterable ? 48 : 0);
      var bottomMargin = showPagination ? 64 : 0;

      if (fixedHeight === 'auto') {
        return minRows;
      } else {
        var reg = /[0-9]+/g;
        var tableHeight = typeof fixedHeight === 'string' ? parseInt(fixedHeight.match(reg)) : fixedHeight;
        var tbodyHeight = tableHeight - topMargin - bottomMargin;
        return parseInt(tbodyHeight / _this.getRowHeightNum());
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isHeaderGroup", function () {
      var columns = _this.props.columns;
      return columns.some(function (array) {
        return array.columns;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTableBodyKeyListener", function (whichKey) {
      var _this$props3 = _this.props,
          defaultPageSize = _this$props3.defaultPageSize,
          virtualScroll = _this$props3.virtualScroll;
      var _this$state2 = _this.state,
          index = _this$state2.index,
          sortedData = _this$state2.sortedData;

      var tableBodyChildrenDiv = _toConsumableArray(_this.tableBodyRef.children).filter(_this.filterDivsFromHTMLNodeList);

      var focusedChildIndex = tableBodyChildrenDiv.indexOf(document.activeElement);

      if (whichKey === 'ArrowDown') {
        if (focusedChildIndex < tableBodyChildrenDiv.length - 1) {
          tableBodyChildrenDiv[focusedChildIndex + 1].focus();
        } else if ( // If the waypoint wasn't triggered, but the user is focused on the last item in the lister - load the next set of items
        virtualScroll && _this.showWaypoint(index, sortedData.length, defaultPageSize, virtualScroll)) {
          _this.loadData({});
        }
      } else if (whichKey === 'ArrowUp' && focusedChildIndex > 0) {
        tableBodyChildrenDiv[focusedChildIndex - 1].focus();
      }
    });

    _this.wrappedInstance = null;

    var nRowHeight = _this.getRowHeightNum(); // Allow custom height of virtualScroll table


    _this.virtualScrollTableHeight = props.virtualScrollTableHeight ? props.virtualScrollTableHeight : props.defaultPageSize * nRowHeight; // eslint-disable-next-line operator-linebreak

    _this.defaultScrollAmount = props.defaultPageSize * (nRowHeight + 1) / 2;
    _this.state = {
      index: 0,
      sortedData: props.data
    };
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.makeFirstTableBodyCellTabbable();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      this.makeFirstTableBodyCellTabbable();

      if (snapshot !== null) {
        this.rtTbodyRef.scrollTop = this.rtTbodyRef.scrollHeight - snapshot.scrollTop;
        this.rtTableRef.scrollLeft = this.rtTableRef.scrollWidth - snapshot.scrollLeft;
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      // This fixes the scroll jump when clicking row and cell
      if (prevProps.getTrProps !== this.props.getTrProps || prevProps.getTdProps !== this.props.getTdProps || prevProps.data !== this.props.data) {
        return {
          scrollTop: this.rtTbodyRef.scrollHeight - this.rtTbodyRef.scrollTop,
          scrollLeft: this.rtTableRef.scrollWidth - this.rtTableRef.scrollLeft
        };
      }

      return null;
    }
  }, {
    key: "tableBodyScroll",
    value: function tableBodyScroll(scrollAmount) {
      if (scrollAmount && this.rtTbodyRef) {
        this.rtTbodyRef.scrollTop = scrollAmount;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          caption = _this$props4.caption,
          className = _this$props4.className,
          columns = _this$props4.columns,
          data = _this$props4.data,
          defaultPageSize = _this$props4.defaultPageSize,
          filterable = _this$props4.filterable,
          fixedHeight = _this$props4.fixedHeight,
          id = _this$props4.id,
          noDataComponent = _this$props4.noDataComponent,
          rowHeight = _this$props4.rowHeight,
          showPageInfo = _this$props4.showPageInfo,
          showPagination = _this$props4.showPagination,
          sortable = _this$props4.sortable,
          striped = _this$props4.striped,
          tabByCell = _this$props4.tabByCell,
          tabByRow = _this$props4.tabByRow,
          virtualScroll = _this$props4.virtualScroll,
          getTrProps = _this$props4.getTrProps,
          getTdProps = _this$props4.getTdProps;
      var _this$state3 = this.state,
          index = _this$state3.index,
          sortedData = _this$state3.sortedData;
      var minRows = this.calculateMinRows();
      var nRowHeight = this.getRowHeightNum();
      var restProps = getValidElementProps('div', this.props);
      var virtualScrollProps = {};

      if (virtualScroll) {
        virtualScrollProps.manual = true;
        virtualScrollProps.onFetchData = this.fetchData;
      }

      var ntClass = classnames({
        table: true
      }, {
        'table--striped': striped
      }, className);

      var TableElement = function TableElement(_ref3) {
        var children = _ref3.children;
        return /*#__PURE__*/React.createElement("div", {
          "aria-label": caption,
          className: "rt-table",
          role: "table",
          ref: function ref(node) {
            return _this2.rtTableRef = node;
          }
        }, children);
      };

      var Theader = function Theader(props) {
        return /*#__PURE__*/React.createElement("div", {
          className: classnames('rt-thead', props.className),
          tabIndex: -1
        }, React.Children.map(props.children, function (child) {
          return React.cloneElement(child, {
            tabByRow: false
          });
        }));
      };

      var TBody = function TBody(_ref4) {
        var children = _ref4.children,
            style = _ref4.style;
        return /*#__PURE__*/React.createElement(TableBody, {
          height: virtualScroll ? _this2.virtualScrollTableHeight : fixedHeight,
          minWidth: style.minWidth,
          onLoadData: _this2.loadData,
          onLoadDataUp: _this2.loadDataUp,
          showWaypoint: virtualScroll ? showWaypoint(index, sortedData.length, defaultPageSize, virtualScroll) : false,
          showWaypointUp: virtualScroll ? showWaypointUp(index, virtualScroll) : false // eslint-disable-next-line no-return-assign
          ,
          tableBodyRef: function tableBodyRef(node) {
            return _this2.tableBodyRef = node;
          },
          rtTbodyRef: function rtTbodyRef(node) {
            return _this2.rtTbodyRef = node;
          },
          verticalScroll: fixedHeight !== 'auto' || virtualScroll,
          onKeyListener: _this2.onTableBodyKeyListener
        }, children);
      };

      var NoDataComponent = noDataComponent ? noDataComponent // eslint-disable-line no-unneeded-ternary
      : function (noDataProps) {
        var headerGroup = _this2.isHeaderGroup(); // eslint-disable-next-line operator-linebreak


        var topMargin = (headerGroup ? 64 : 48) + (filterable ? 48 : 0) + 1;
        var componentHeight = minRows * nRowHeight;
        return /*#__PURE__*/React.createElement("div", {
          className: "table__noData",
          style: {
            top: topMargin,
            height: "".concat(componentHeight, "px")
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "h3 margin-none"
        }, noDataProps.children));
      };
      var defaultFilterMethod = this.props.defaultFilterMethod;

      if (!defaultFilterMethod) {
        defaultFilterMethod = function defaultFilterMethod(filter, row) {
          var id = filter.pivotId || filter.id;
          return row[id] !== undefined ? filterMatch(row[id], filter.value, true, true) : true;
        };
      }

      return /*#__PURE__*/React.createElement(ReactTable, _extends({}, restProps, this.props, virtualScrollProps, {
        FilterComponent: function FilterComponent(props) {
          return /*#__PURE__*/React.createElement(TableFilter, _extends({
            id: id
          }, props));
        },
        NoDataComponent: NoDataComponent,
        PaginationComponent: Pagination,
        TableComponent: TableElement,
        TbodyComponent: TBody,
        TdComponent: function TdComponent(props) {
          return (// eslint-disable-next-line implicit-arrow-linebreak
            TableData(_objectSpread({
              rowHeight: rowHeight,
              tabByCell: tabByCell
            }, props))
          );
        },
        ThComponent: function ThComponent(props) {
          return /*#__PURE__*/React.createElement(TableHeader, _extends({
            sortable: true
          }, props));
        },
        TheadComponent: Theader,
        TrComponent: function TrComponent(props) {
          return (// eslint-disable-next-line implicit-arrow-linebreak
            TableRow(_objectSpread({
              tabByRow: tabByRow,
              rowHeight: rowHeight
            }, props))
          );
        },
        TrGroupComponent: TableRowGroup,
        className: ntClass,
        columns: columns,
        data: virtualScroll ? getDataSlice({
          sortedData: sortedData,
          defaultPageSize: defaultPageSize,
          index: index
        }) : data,
        defaultFilterMethod: defaultFilterMethod,
        filterable: filterable,
        getTrProps: getTrProps,
        getTdProps: getTdProps,
        minRows: minRows // eslint-disable-next-line no-return-assign
        ,
        ref: function ref(_ref5) {
          return _this2.wrappedInstance = _ref5;
        },
        showPageInfo: showPageInfo,
        showPagination: virtualScroll ? !virtualScroll : showPagination,
        sortable: sortable,
        style: {
          height: fixedHeight
        },
        tabByCell: tabByCell,
        tabByRow: tabByRow
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var sortedData = prevState.sortedData;

      if (nextProps.virtualScroll && nextProps.data.length !== sortedData.length) {
        return {
          sortedData: nextProps.data
        };
      }

      return null;
    }
  }]);

  return Table;
}(Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
Table.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getRowHeightNum",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "makeFirstTableBodyCellTabbable",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "getWrappedInstance",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "filterDivsFromHTMLNodeList",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "HTMLNodeList",
      "type": null
    }],
    "returns": null
  }, {
    "name": "loadData",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "loadDataUp",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "customSort",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "col",
      "type": null
    }, {
      "name": "desc",
      "type": null
    }, {
      "name": "id",
      "type": null
    }, {
      "name": "sortedData",
      "type": null
    }],
    "returns": null
  }, {
    "name": "genericSort",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "id",
      "type": null
    }, {
      "name": "sorted",
      "type": null
    }, {
      "name": "data",
      "type": null
    }],
    "returns": null
  }, {
    "name": "fetchData",
    "docblock": null,
    "modifiers": ["async"],
    "params": [{
      "name": "tableState",
      "type": null
    }],
    "returns": null
  }, {
    "name": "calculateMinRows",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "isHeaderGroup",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTableBodyKeyListener",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "whichKey",
      "type": null
    }],
    "returns": null
  }, {
    "name": "tableBodyScroll",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "scrollAmount",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Table",
  "props": {
    "caption": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Description of the table"
    },
    "columns": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Columns for your table. There is more customization can be done in this columns object. Please refer to https://react-table.js.org"
    },
    "data": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Data for your table"
    },
    "defaultPageSize": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Number of rows of data by default"
    },
    "filterable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Enable columns to be filterable using search input below table header"
    },
    "fixedHeight": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Make table a fixed height with a fixed header. You can put string (\"500px\") or number {500}"
    },
    "minRows": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Displays minimum number of rows when filtered"
    },
    "noDataComponent": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Replace the entire no data message component with a functional render (function should return a Node)"
    },
    "noDataText": {
      "defaultValue": {
        "value": "'No results found.'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Textual message overlaid on the table when there are no data rows"
    },
    "pageSizeDropUp": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "rowHeight": {
      "defaultValue": {
        "value": "'medium'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Table row height for table density level: small (32px), medium (40px), large (48px)"
    },
    "showPageInfo": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display the page info (Page 1 of 10) on the left side of pagination"
    },
    "showPageSizeOptions": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display page size options on the right side of pagination"
    },
    "showPagination": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Include Pagination Component"
    },
    "sortable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Enable columns to be sortable"
    },
    "striped": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Style of table"
    },
    "tabByCell": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Navigate table cell by cell using keyboard tab key"
    },
    "tabByRow": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Navigate table row by row using keyboard tab key"
    },
    "virtualScroll": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set to true to have virtual/infinite scrolling without pagination"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "id of the table for accessibility purpose, passed down to sub components"
    },
    "defaultFilterMethod": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "defaultFilterMethod for the table"
    },
    "getTdProps": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Get info on table cell state for modifying (e.g. on clicking the cell)"
    },
    "getTrProps": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Get info on table row state for modifying (e.g. on clicking the row)"
    },
    "pageSizeOptions": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Options for number of rows on display"
    },
    "virtualScrollTableHeight": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Make virtualScroll table a fixed height with a fixed header. You can put string (\"500px\") or number {500}"
    }
  }
};
export default Table;